// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2c8Gs","infoBtn":"quickbooks_infoBtn__1PwAo","formBox":"quickbooks_formBox__1qgiw","formFooter":"quickbooks_formFooter__2t6dt"};